import { useCallback, useEffect, useRef, useState } from 'react'

export function useTabsScroll(enabled: boolean) {
  const ref = useRef<HTMLDivElement>(null)
  const [canScrollLeft, setCanScrollLeft] = useState(false)
  const [canScrollRight, setCanScrollRight] = useState(false)

  const updateScrollState = useCallback(() => {
    const element = ref.current
    if (!element) return

    const { scrollLeft, scrollWidth, clientWidth } = element
    setCanScrollLeft(scrollLeft > 0)
    setCanScrollRight(scrollLeft + clientWidth < scrollWidth - 1)
  }, [])

  useEffect(() => {
    if (!enabled) return

    const element = ref.current
    if (!element) return

    updateScrollState()

    element.addEventListener('scroll', updateScrollState, { passive: true })
    const resizeObserver = new ResizeObserver(updateScrollState)
    resizeObserver.observe(element)

    return () => {
      element.removeEventListener('scroll', updateScrollState)
      resizeObserver.disconnect()
    }
  }, [enabled, updateScrollState])

  const scroll = useCallback((direction: 'left' | 'right') => {
    const element = ref.current
    if (!element) return

    element.scrollBy({
      left: direction === 'left' ? -element.clientWidth : element.clientWidth,
      behavior: 'smooth',
    })
  }, [])

  return { ref, canScrollLeft, canScrollRight, scroll }
}
